import styled from 'styled-components';
import { Wrapper } from 'AppReact';

const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 12px;
  margin-top: 10px;
  color: #334D6E;
`;

export default Wrapper(FooterWrapper);
